// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@conklin/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@conklin/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain as RemoveCartLineChain,
    DispatchCompleteRemoveCartLine,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";

export const _GaRemoveCartLine: typeof DispatchCompleteRemoveCartLine = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (state.xGoogleAnalytics.removeFromCartLineEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const cart = getCurrentCartState(props.getState()).value;
        const cartLine = cart?.cartLines?.find(c => c.id === props.apiParameter.cartLineId);
        const session = getSession(state);

        if (!cartLine) {
            return;
        }

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.removeFromCartLineEventName,
            currency: session.currency?.currencyCode,
            value: cart?.orderGrandTotal,
            affiliation: state.xGoogleAnalytics.affiliation,
            items: [
                {
                    item_name: cartLine.shortDescription,
                    item_id: cartLine.erpNumber,
                    price: cartLine.pricing?.unitNetPrice,
                    quantity: cartLine.qtyOrdered,
                    index: cartLine.line,
                    discount: cartLine.pricing
                        ? cartLine.pricing.unitNetPrice < cartLine.pricing.unitListPrice
                            ? cartLine.pricing.unitListPrice - cartLine.pricing.unitNetPrice
                            : 0
                        : 0,
                    item_brand: state.xGoogleAnalytics.includeProductBrand ? cartLine.brand?.name || "" : undefined,
                    item_category: state.xGoogleAnalytics.includeProductCategory
                        ? cartLine.properties?.["category"] || ""
                        : undefined,
                    item_list_id: state.xGoogleAnalytics.includeProductCategory
                        ? cartLine.properties?.["categoryId"] || ""
                        : undefined,
                    affiliation: state.xGoogleAnalytics.affiliation,
                },
            ],
        };

        dataLayer.push(googleAnalyticsData);
    }
};

addToEndOfChain(RemoveCartLineChain, _GaRemoveCartLine);
